import { ApolloQueryResult, useMutation } from '@apollo/client';
import React, { useRef, useState } from 'react';

import { Button, HStack, Input, useShowMessage } from '../../../core-ui';
import { useShowApolloError } from '../../../support/graphql/useShowApolloError';
import { CREATE_SALES_NOTE } from './graphql';
import {
  CreateSalesNote,
  CreateSalesNoteVariables,
} from './__generated__/CreateSalesNote';
import { GetSalesNotesBySalesId } from './__generated__/GetSalesNotesBySalesId';

type Props = {
  refetch: () => Promise<ApolloQueryResult<GetSalesNotesBySalesId>>;
  salesId: string;
  userId: string;
};

export function CreateSalesNoteFooter(props: Props) {
  const { refetch, salesId, userId } = props;

  const [value, setValue] = useState('');

  const createNoteRef = useRef<HTMLButtonElement>(null);
  const showMessage = useShowMessage();
  const showApolloError = useShowApolloError();
  const [createSalesNote] = useMutation<
    CreateSalesNote,
    CreateSalesNoteVariables
  >(CREATE_SALES_NOTE, {
    onError: showApolloError,
    onCompleted: async () => {
      await refetch();
    },
  });

  const createNote = async () => {
    const noteLengthLimit = 1000;
    if (value.length > noteLengthLimit) {
      showMessage(
        'error',
        t('Length of note exceeds {noteLengthLimit}', { noteLengthLimit }),
      );
    } else if (value.length === 0) {
      showMessage('error', t('Cannot create empty note'));
    } else {
      await createSalesNote({
        variables: {
          input: {
            content: value,
            isHidden: false,
            vendorSales: salesId,
            user: userId,
          },
        },
      });
      setValue('');
    }
  };
  return (
    <HStack backgroundColor="#f2f2f2" borderRadius="10px" p={2}>
      <Input
        backgroundColor="white"
        onChange={(event) => setValue(event.target.value)}
        placeholder={t('Write your note here')}
        value={value}
        onKeyUp={(event) => {
          if (event.key === 'Enter') {
            createNoteRef.current?.focus();
          }
        }}
      />
      <Button border="2px solid black" onClick={createNote} ref={createNoteRef}>
        {t('Create Note')}
      </Button>
    </HStack>
  );
}
